export type DostupnostTechnikaDuvod = 'KONDICNI_JIZDA' | 'SERVIS' | 'SOUTEZ' | 'NAKUP_PHM' | 'JINE';

export const DUVOD_LABELS: Record<DostupnostTechnikaDuvod, string> = {
    KONDICNI_JIZDA: 'Kondiční jízda',
    SERVIS: 'Servis',
    SOUTEZ: 'Soutěž',
    NAKUP_PHM: 'Nákup PHM',
    JINE: 'Jiné',
};

export interface DostupnostTechnika {
    id: number;
    technikaId: number;
    stav: 'DOSTUPNA' | 'NEDOSTUPNA';
    duvod?: DostupnostTechnikaDuvod;
    poznamka?: string;
    platnostOd?: string;
    platnostDo?: string;       // undefined/null = do odvolani
    aktivni: boolean;
    vytvorilId?: number;       // muze byt NULL po smazani clena (FK ON DELETE SET NULL)
    vytvorilJmeno?: string;
    technikaNazev?: string;
    volaciZnak?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface TechnikaDostupnostPrehled {
    technikaId: number;
    nazev: string;
    volaciZnak: string;
    spz?: string;
    dostupnost: DostupnostTechnika | null;   // null = vozidlo dostupne
}

export interface SetDostupnostTechnikaRequest {
    duvod: DostupnostTechnikaDuvod;
    poznamka?: string;
    platnostOd?: string | null;
    platnostDo?: string | null;
}
